import React, { Component } from 'react';
import { Modal, Button, Form, Alert, Spinner } from 'react-bootstrap';
import { GoogleLogin } from '@react-oauth/google';
import { register, googleLogin } from '../services/api';
import { FiCamera } from 'react-icons/fi';
import i18n from '../i18n';

class RegisterModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            username: '',
            email: '',
            password: '',
            confirmPassword: '',
            avatar: null,
            avatarPreview: null,
            acceptTerms: false, // Aggiungi questo campo per la spunta
            isLoading: false,
            error: null,
            success: false,
            validationErrors: {},
            showTerms: false,
            showPrivacy: false,
            step: 1, // wizard step 1-3
        };
    }

    handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        this.setState({ 
            [name]: type === 'checkbox' ? checked : value,
            validationErrors: {
                ...this.state.validationErrors,
                [name]: null
            }
        });
    } 

    handleImageChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            // Verifica che il file sia un'immagine
            if (!file.type.match('image.*')) {
                this.setState({
                    validationErrors: {
                        ...this.state.validationErrors,
                        avatar: 'Per favore seleziona un file immagine valido'
                    }
                });
                return;
            }
            
            // Verifica la dimensione del file (max 5MB)
            if (file.size > 5 * 1024 * 1024) {
                this.setState({
                    validationErrors: {
                        ...this.state.validationErrors,
                        avatar: 'L immagine non può superare i 5MB'
                    }
                });
                return;
            }
            
            // Crea un'anteprima dell'immagine
            const reader = new FileReader();
            reader.onloadend = () => {
                this.setState({
                    avatar: file,
                    avatarPreview: reader.result,
                    validationErrors: {
                        ...this.state.validationErrors,
                        avatar: null
                    }
                });
            };
            reader.readAsDataURL(file);
            
            console.log('Immagine selezionata:', file.name, file.type, file.size);
        }
    }

    validateForm = () => {
        const { username, email, password, confirmPassword, acceptTerms } = this.state;
        const validationErrors = {};
        let isValid = true;

        // Validazione username
        if (!username.trim()) {
            validationErrors.username = 'Il nome utente è obbligatorio';
            isValid = false;
        } else if (username.length < 3) {
            validationErrors.username = 'Il nome utente deve contenere almeno 3 caratteri';
            isValid = false;
        }

        // Validazione email
        if (!email.trim()) {
            validationErrors.email = 'L email è obbligatoria';
            isValid = false;
        } else if (!/\S+@\S+\.\S+/.test(email)) {
            validationErrors.email = 'Inserisci un indirizzo email valido';
            isValid = false;
        }

        // Validazione password
        if (!password) {
            validationErrors.password = 'La password è obbligatoria';
            isValid = false;
        } else if (password.length < 8) {
            validationErrors.password = 'La password deve contenere almeno 8 caratteri';
            isValid = false;
        }

        // Validazione conferma password
        if (password !== confirmPassword) {
            validationErrors.confirmPassword = 'Le password non coincidono';
            isValid = false;
        }
        
        // Validazione accettazione termini
        if (!acceptTerms) {
            validationErrors.acceptTerms = 'Devi accettare i Termini e Condizioni e l Informativa sulla Privacy';
            isValid = false;
        }

        this.setState({ validationErrors });
        return isValid;
    }

    handleSubmit = async (event) => {
        event.preventDefault();
        
        if (!this.validateForm()) {
            return;
        }

        this.setState({ isLoading: true, error: null, success: false });
        
        try {
            const { username, email, password, avatar } = this.state;
            
            // Crea un oggetto FormData per inviare anche il file
            const formData = new FormData();
            formData.append('username', username);
            formData.append('email', email);
            formData.append('password', password);
            formData.append('bio', ''); // Aggiungi esplicitamente il campo bio
            
            // Aggiungi l'avatar solo se è stato selezionato
            if (avatar) {
                formData.append('avatar', avatar);
            }
            
            // Log per debug
            console.log("FormData creato nel componente:");
            for (let pair of formData.entries()) {
                console.log(pair[0] + ': ' + (pair[1] instanceof File ? pair[1].name : pair[1]));
            }
            
            // Chiamata API per la registrazione
            await register(formData);
            
            if (window.gtag) window.gtag('event', 'conversion', { 'send_to': 'AW-17659539709/XO_SCOfP3q4bEP3h3ORB' });
            this.setState({
                username: '',
                email: '',
                password: '',
                confirmPassword: '',
                avatar: null,
                avatarPreview: null,
                success: true,
                isLoading: false
            });
            
            // Dopo 2 secondi, chiudi il modal e reimposta lo stato
            setTimeout(() => {
                if (this.props.onHide) {
                    this.props.onHide();
                }
                this.setState({ success: false });
            }, 2000);
            
        } catch (error) {
            console.error('Registration error:', error);
            console.error('Error response:', error.response);
            
            let errorMessage = 'Si è verificato un errore durante la registrazione';
            
            if (error.response) {
                console.error('Status:', error.response.status);
                console.error('Data:', error.response.data);
                
                const responseData = error.response.data;
                
                if (typeof responseData === 'string') {
                    errorMessage = responseData;
                } else if (responseData.username) {
                    errorMessage = `Username: ${responseData.username.join(', ')}`;
                } else if (responseData.email) {
                    errorMessage = `Email: ${responseData.email.join(', ')}`;
                } else if (responseData.password) {
                    errorMessage = `Password: ${responseData.password.join(', ')}`;
                } else if (responseData.avatar) {
                    errorMessage = `Immagine: ${responseData.avatar.join(', ')}`;
                } else if (responseData.non_field_errors) {
                    errorMessage = responseData.non_field_errors.join(', ');
                } else if (responseData.detail) {
                    errorMessage = responseData.detail;
                } else if (responseData.error) {
                    errorMessage = responseData.error;
                }
            } else if (error.message) {
                errorMessage = error.message;
            }
            
            this.setState({
                error: errorMessage,
                isLoading: false
            });
        }
    }

    nextStep = () => {
        const { step, username, email, password, confirmPassword } = this.state;
        const errs = {};
        if (step === 1) {
            if (!username.trim() || username.length < 3) errs.username = 'Minimo 3 caratteri';
            if (!email.trim() || !/\S+@\S+\.\S+/.test(email)) errs.email = 'Email non valida';
        }
        if (step === 2) {
            if (!password || password.length < 8) errs.password = 'Minimo 8 caratteri';
            if (password !== confirmPassword) errs.confirmPassword = 'Le password non coincidono';
        }
        if (Object.keys(errs).length) { this.setState({ validationErrors: errs }); return; }
        this.setState({ step: step + 1, validationErrors: {} });
    };
    prevStep = () => this.setState(s => ({ step: s.step - 1, validationErrors: {} }));

    openTerms = (e) => {
        e.preventDefault();
        this.setState({ showTerms: true });
    }
    
    openPrivacy = (e) => {
        e.preventDefault();
        this.setState({ showPrivacy: true });
    }
    
    closeTerms = () => {
        this.setState({ showTerms: false });
    }
    
    closePrivacy = () => {
        this.setState({ showPrivacy: false });
    }

    render() {
        const { show, onHide, onSwitchToLogin } = this.props;
        const {
            username, email, password, confirmPassword, acceptTerms,
            avatarPreview, isLoading, error, success, validationErrors,
            showTerms, showPrivacy, step
        } = this.state;

        const isEn = i18n.language === 'en';
        const STEPS = isEn ? ['Account', 'Password', 'Profile'] : ['Account', 'Password', 'Profilo'];
        const gradBtn = { background: 'linear-gradient(135deg,var(--primary),var(--secondary))', border: 'none', borderRadius: '9999px', fontWeight: 700, padding: '0.6rem 1.8rem' };
        const handleGoogleSuccess = async (credentialResponse) => {
            this.setState({ isLoading: true, error: null });
            try {
                const data = await googleLogin(credentialResponse.credential);
                localStorage.setItem('token', data.token);
                localStorage.setItem('login_time', Date.now().toString());
                localStorage.setItem('user', JSON.stringify({ id: data.user_id, username: data.username, email: data.email }));
                if (window.gtag) window.gtag('event', 'conversion', { 'send_to': 'AW-17659539709/XO_SCOfP3q4bEP3h3ORB' });
                this.setState({ success: true, isLoading: false });
                setTimeout(() => { onHide?.(); this.setState({ success: false }); }, 1500);
            } catch {
                this.setState({ error: isEn ? 'Google sign-in failed. Please try again.' : 'Accesso Google fallito. Riprova.', isLoading: false });
            }
        };

        return (
            <>
                <Modal show={show} onHide={onHide} centered>
                    <Modal.Header closeButton style={{ border: 'none', paddingBottom: 0 }}>
                        {/* Progress steps */}
                        <div style={{ width: '100%' }}>
                            <div style={{ display: 'flex', justifyContent: 'center', gap: '0.5rem', marginBottom: '0.75rem' }}>
                                {STEPS.map((s, i) => {
                                    const n = i + 1;
                                    const done = step > n;
                                    const active = step === n;
                                    return (
                                        <div key={s} style={{ display: 'flex', alignItems: 'center', gap: '0.4rem' }}>
                                            <div style={{
                                                width: 28, height: 28, borderRadius: '50%', display: 'flex',
                                                alignItems: 'center', justifyContent: 'center', fontSize: '0.78rem', fontWeight: 700,
                                                background: done ? '#10B981' : active ? 'linear-gradient(135deg,var(--primary),var(--secondary))' : '#E5E7EB',
                                                color: (done || active) ? '#fff' : '#9CA3AF',
                                                transition: 'all 0.3s',
                                            }}>
                                                {done ? '✓' : n}
                                            </div>
                                            <span style={{ fontSize: '0.75rem', fontWeight: active ? 700 : 500, color: active ? 'var(--primary)' : '#9CA3AF' }}>{s}</span>
                                            {i < STEPS.length - 1 && <div style={{ width: 24, height: 2, background: done ? '#10B981' : '#E5E7EB', borderRadius: 2 }} />}
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    </Modal.Header>
                    <Modal.Body style={{ padding: '1.5rem 2rem' }}>
                        {error && <Alert variant="danger" className="mb-3">{error}</Alert>}
                        {success ? (
                            <div style={{ textAlign: 'center', padding: '2rem 0' }}>
                                <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>🎉</div>
                                <h5 style={{ fontWeight: 800, color: '#0F172A' }}>{isEn ? 'Welcome to Happy Events!' : 'Benvenuto in Happy Events!'}</h5>
                                <p style={{ color: '#64748B' }}>{isEn ? 'Account created successfully.' : 'Account creato con successo.'}</p>
                            </div>
                        ) : (
                            <Form onSubmit={step === 3 ? this.handleSubmit : e => { e.preventDefault(); this.nextStep(); }}>

                                {/* ── Google sign-up (solo step 1) ── */}
                                {step === 1 && (
                                    <>
                                        <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '1rem' }}>
                                            <GoogleLogin
                                                onSuccess={handleGoogleSuccess}
                                                onError={() => this.setState({ error: isEn ? 'Google sign-in failed.' : 'Accesso Google fallito.' })}
                                                text="signup_with"
                                                shape="pill"
                                                locale="it"
                                            />
                                        </div>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', marginBottom: '1.25rem' }}>
                                            <div style={{ flex: 1, height: 1, background: '#e5e7eb' }} />
                                            <span style={{ fontSize: '0.78rem', color: '#9ca3af', fontWeight: 600 }}>{isEn ? 'or sign up with email' : 'oppure registrati con email'}</span>
                                            <div style={{ flex: 1, height: 1, background: '#e5e7eb' }} />
                                        </div>
                                    </>
                                )}

                                {/* ── Step 1: Account ── */}
                                {step === 1 && (
                                    <>
                                        <div style={{ textAlign: 'center', marginBottom: '1.5rem' }}>
                                            <h5 style={{ fontWeight: 800, margin: 0 }}>{isEn ? 'Create your account' : 'Crea il tuo account'}</h5>
                                            <p style={{ color: '#64748B', fontSize: '0.88rem', marginTop: '0.3rem' }}>{isEn ? 'Start with your username and email' : 'Inizia con username ed email'}</p>
                                        </div>
                                        <Form.Group className="mb-3">
                                            <Form.Label style={{ fontWeight: 600, fontSize: '0.88rem' }}>Username</Form.Label>
                                            <Form.Control type="text" name="username" value={username} onChange={this.handleChange}
                                                isInvalid={!!validationErrors.username} placeholder="es. mario_rossi" style={{ borderRadius: 12, height: 46 }} />
                                            <Form.Control.Feedback type="invalid">{validationErrors.username}</Form.Control.Feedback>
                                        </Form.Group>
                                        <Form.Group className="mb-4">
                                            <Form.Label style={{ fontWeight: 600, fontSize: '0.88rem' }}>Email</Form.Label>
                                            <Form.Control type="email" name="email" value={email} onChange={this.handleChange}
                                                isInvalid={!!validationErrors.email} placeholder="tua@email.it" style={{ borderRadius: 12, height: 46 }} />
                                            <Form.Control.Feedback type="invalid">{validationErrors.email}</Form.Control.Feedback>
                                        </Form.Group>
                                    </>
                                )}

                                {/* ── Step 2: Password ── */}
                                {step === 2 && (
                                    <>
                                        <div style={{ textAlign: 'center', marginBottom: '1.5rem' }}>
                                            <h5 style={{ fontWeight: 800, margin: 0 }}>{isEn ? 'Choose a password' : 'Scegli una password'}</h5>
                                            <p style={{ color: '#64748B', fontSize: '0.88rem', marginTop: '0.3rem' }}>{isEn ? 'At least 8 characters' : 'Almeno 8 caratteri'}</p>
                                        </div>
                                        <Form.Group className="mb-3">
                                            <Form.Label style={{ fontWeight: 600, fontSize: '0.88rem' }}>Password</Form.Label>
                                            <Form.Control type="password" name="password" value={password} onChange={this.handleChange}
                                                isInvalid={!!validationErrors.password} placeholder="••••••••" style={{ borderRadius: 12, height: 46 }} />
                                            <Form.Control.Feedback type="invalid">{validationErrors.password}</Form.Control.Feedback>
                                            {password && (
                                                <div style={{ marginTop: '0.5rem', display: 'flex', gap: 4 }}>
                                                    {[1,2,3,4].map(i => (
                                                        <div key={i} style={{ flex:1, height:4, borderRadius:4,
                                                            background: password.length >= i*2 ? (password.length >= 8 ? '#10B981' : 'var(--accent)') : '#E5E7EB'
                                                        }} />
                                                    ))}
                                                </div>
                                            )}
                                        </Form.Group>
                                        <Form.Group className="mb-4">
                                            <Form.Label style={{ fontWeight: 600, fontSize: '0.88rem' }}>{isEn ? 'Confirm password' : 'Conferma password'}</Form.Label>
                                            <Form.Control type="password" name="confirmPassword" value={confirmPassword} onChange={this.handleChange}
                                                isInvalid={!!validationErrors.confirmPassword} placeholder="••••••••" style={{ borderRadius: 12, height: 46 }} />
                                            <Form.Control.Feedback type="invalid">{validationErrors.confirmPassword}</Form.Control.Feedback>
                                        </Form.Group>
                                    </>
                                )}

                                {/* ── Step 3: Avatar + Terms ── */}
                                {step === 3 && (
                                    <>
                                        <div style={{ textAlign: 'center', marginBottom: '1.25rem' }}>
                                            <h5 style={{ fontWeight: 800, margin: 0 }}>{isEn ? 'Personalise your profile' : 'Personalizza il profilo'}</h5>
                                            <p style={{ color: '#64748B', fontSize: '0.88rem', marginTop: '0.3rem' }}>{isEn ? 'Optional photo + accept terms' : 'Foto opzionale + accetta i termini'}</p>
                                        </div>
                                        {/* Avatar */}
                                        <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '1.25rem' }}>
                                            <div style={{ position: 'relative', width: 100, height: 100, borderRadius: '50%', overflow: 'hidden',
                                                background: 'var(--gradient-soft)', border: '3px solid #EDE9FE', cursor: 'pointer' }}
                                                onClick={() => document.getElementById('avatar-upload').click()}>
                                                {avatarPreview
                                                    ? <img src={avatarPreview} alt="" style={{ width:'100%', height:'100%', objectFit:'cover' }} />
                                                    : <div style={{ width:'100%', height:'100%', display:'flex', alignItems:'center', justifyContent:'center', fontSize:'2.5rem' }}>👤</div>
                                                }
                                                <div style={{ position:'absolute', bottom:0, width:'100%', background:'rgba(0,0,0,0.5)', color:'#fff', textAlign:'center', fontSize:'0.7rem', padding:'3px 0' }}>
                                                    <FiCamera size={12} /> {isEn ? 'photo' : 'foto'}
                                                </div>
                                                <Form.Control id="avatar-upload" type="file" accept="image/*" onChange={this.handleImageChange} style={{ display:'none' }} />
                                            </div>
                                        </div>
                                        {/* Terms */}
                                        <Form.Group className="mb-3">
                                            <Form.Check type="checkbox" id="accept-terms" name="acceptTerms" checked={acceptTerms}
                                                onChange={this.handleChange} isInvalid={!!validationErrors.acceptTerms}
                                                label={<span style={{ fontSize: '0.85rem' }}>{isEn ? 'I accept the' : 'Accetto i'}{' '}
                                                    <button type="button" style={{ background:'none',border:'none',color:'var(--primary)',fontWeight:700,padding:0,cursor:'pointer' }} onClick={this.openTerms}>{isEn ? 'Terms' : 'Termini'}</button>{isEn ? ' and the ' : ' e la '}
                                                    <button type="button" style={{ background:'none',border:'none',color:'var(--primary)',fontWeight:700,padding:0,cursor:'pointer' }} onClick={this.openPrivacy}>Privacy</button>
                                                </span>} />
                                            <Form.Control.Feedback type="invalid">{validationErrors.acceptTerms}</Form.Control.Feedback>
                                        </Form.Group>
                                    </>
                                )}

                                {/* Navigation buttons */}
                                <div style={{ display: 'flex', gap: '0.75rem', marginTop: '0.5rem' }}>
                                    {step > 1 && (
                                        <Button type="button" variant="light" onClick={this.prevStep} style={{ borderRadius: '9999px', flex: 1 }}>
                                            {isEn ? '← Back' : '← Indietro'}
                                        </Button>
                                    )}
                                    <Button type="submit" disabled={isLoading} style={{ ...gradBtn, flex: 1 }}>
                                        {isLoading ? <><Spinner as="span" animation="border" size="sm" className="me-2" />{isEn ? 'Creating...' : 'Creazione...'}</>
                                            : step < 3 ? (isEn ? 'Next →' : 'Avanti →') : (isEn ? 'Create account' : 'Crea account')}
                                    </Button>
                                </div>

                                <div style={{ textAlign: 'center', marginTop: '1rem', fontSize: '0.85rem', color: '#64748B' }}>
                                    {isEn ? 'Already have an account?' : 'Hai già un account?'}{' '}
                                    <button type="button" style={{ background:'none',border:'none',color:'var(--primary)',fontWeight:700,cursor:'pointer',padding:0 }}
                                        onClick={onSwitchToLogin}>{isEn ? 'Log in' : 'Accedi'}</button>
                                </div>
                            </Form>
                        )}
                    </Modal.Body>
                </Modal>
                
                {/* Modal per i Termini e Condizioni */}
                <Modal show={showTerms} onHide={this.closeTerms} size="lg">
                    <Modal.Header closeButton>
                        <Modal.Title>{i18n.language === 'en' ? 'Terms and Conditions' : 'Termini e Condizioni'}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="terms-content">
                            <h2>1. Accettazione dei Termini</h2>
                            <p>
                                Utilizzando il sito web, l'applicazione mobile o i servizi di Happy Events (collettivamente, i "Servizi"), 
                                accetti di essere vincolato da questi Termini e Condizioni. Se non accetti questi termini, 
                                ti preghiamo di non utilizzare i nostri Servizi.
                            </p>
                            
                            <h2>2. Descrizione del Servizio</h2>
                            <p>
                                Happy Events è una piattaforma che consente agli utenti di scoprire, creare e partecipare a eventi. 
                                I nostri Servizi includono il sito web, l'applicazione mobile e tutte le funzionalità, API e altri servizi correlati.
                            </p>
                            
                            <h2>3. Registrazione dell'Account</h2>
                            <p>
                                Per utilizzare alcune funzionalità dei nostri Servizi, potrebbe essere necessario creare un account. 
                                Sei responsabile del mantenimento della riservatezza delle credenziali del tuo account e di tutte le attività 
                                che si verificano sotto il tuo account.
                            </p>
                            
                            <h2>4. Contenuti dell'Utente</h2>
                            <p>
                                I nostri Servizi consentono di pubblicare, collegare, archiviare, condividere e rendere disponibili 
                                determinate informazioni, testi, grafica, video o altri materiali ("Contenuti"). 
                                Sei responsabile dei Contenuti che pubblichi sui nostri Servizi, inclusa la loro legalità, affidabilità e appropriatezza.
                            </p>
                            
                            <h2>5. Diritti di Proprietà Intellettuale</h2>
                            <p>
                                I Servizi e i loro contenuti originali, funzionalità e funzionalità sono e rimarranno di proprietà esclusiva 
                                di Happy Events e dei suoi licenziatari. I Servizi sono protetti da copyright, marchio e altre leggi.
                            </p>
                            
                            <h2>6. Collegamenti ad Altri Siti Web</h2>
                            <p>
                                I nostri Servizi possono contenere collegamenti a siti web o servizi di terze parti che non sono di proprietà 
                                o controllati da Happy Events. Happy Events non ha alcun controllo e non si assume alcuna responsabilità 
                                per il contenuto, le politiche sulla privacy o le pratiche di siti web o servizi di terze parti.
                            </p>
                            
                            <h2>7. Risoluzione</h2>
                            <p>
                                Possiamo terminare o sospendere il tuo account e l'accesso ai nostri Servizi immediatamente, 
                                senza preavviso o responsabilità, per qualsiasi motivo, incluso, senza limitazione, 
                                la violazione dei presenti Termini.
                            </p>
                            
                            <h2>8. Limitazione di Responsabilità</h2>
                            <p>
                                In nessun caso Happy Events, né i suoi direttori, dipendenti, partner, agenti, fornitori o affiliati, 
                                saranno responsabili per qualsiasi danno indiretto, incidentale, speciale, conseguenziale o punitivo, 
                                inclusi, senza limitazione, perdita di profitti, dati, uso, avviamento o altre perdite immateriali, 
                                derivanti da (i) il tuo accesso o utilizzo o incapacità di accedere o utilizzare i Servizi; 
                                (ii) qualsiasi condotta o contenuto di terze parti sui Servizi; 
                                (iii) qualsiasi contenuto ottenuto dai Servizi; e (iv) accesso non autorizzato, 
                                uso o alterazione delle tue trasmissioni o contenuti.
                            </p>
                            
                            <h2>9. Legge Applicabile</h2>
                            <p>
                                Questi Termini saranno regolati e interpretati in conformità con le leggi italiane, 
                                senza riguardo alle disposizioni sui conflitti di legge.
                            </p>
                            
                            <h2>10. Modifiche ai Termini</h2>
                            <p>
                                Ci riserviamo il diritto, a nostra esclusiva discrezione, di modificare o sostituire questi Termini in qualsiasi momento. 
                                Se una revisione è materiale, cercheremo di fornire un preavviso di almeno 30 giorni prima che i nuovi termini entrino in vigore.
                            </p>
                        </div>
                    </Modal.Body>
                </Modal>
                
                {/* Modal per l'Informativa sulla Privacy */}
                <Modal show={showPrivacy} onHide={this.closePrivacy} size="lg">
                    <Modal.Header closeButton>
                        <Modal.Title>{i18n.language === 'en' ? 'Privacy Policy' : 'Informativa sulla Privacy'}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="privacy-content">
                            <h2>1. Introduzione</h2>
                            <p>
                                La presente Informativa sulla Privacy descrive come Happy Events (&quot;noi&quot;, &quot;nostro&quot; o &quot;Happy Events&quot;) 
                                raccoglie, utilizza e condivide i tuoi dati personali quando utilizzi il nostro sito web, 
                                la nostra applicazione mobile o i nostri servizi (collettivamente, i &quot;Servizi&quot;).
                            </p>

                            <h2>2. Dati che raccogliamo</h2>
                            <p>Possiamo raccogliere i seguenti tipi di informazioni:</p>
                            <ul>
                                <li><strong>Informazioni personali:</strong> nome, indirizzo email, numero di telefono, indirizzo postale.</li>
                                <li><strong>Informazioni di account:</strong> nome utente, password, preferenze di account.</li>
                                <li><strong>Informazioni di pagamento:</strong> dati della carta di credito, informazioni di fatturazione.</li>
                                <li><strong>Informazioni sul dispositivo:</strong> indirizzo IP, tipo di browser, provider di servizi Internet.</li>
                                <li><strong>Dati di utilizzo:</strong> pagine visitate, tempo trascorso sul sito, link cliccati.</li>
                                <li><strong>Dati di geolocalizzazione:</strong> posizione geografica per mostrarti eventi nelle vicinanze.</li>
                            </ul>

                            <h2>3. Come utilizziamo i tuoi dati</h2>
                            <p>Utilizziamo i tuoi dati personali per:</p>
                            <ul>
                                <li>Fornire, mantenere e migliorare i nostri Servizi</li>
                                <li>Elaborare transazioni e inviare notificazioni correlate</li>
                                <li>Inviare comunicazioni di marketing, aggiornamenti e promozioni</li>
                                <li>Rispondere alle tue richieste e fornire assistenza clienti</li>
                                <li>Monitorare e analizzare tendenze, utilizzo e attività</li>
                                <li>Prevenire attività fraudolenta e migliorare la sicurezza</li>
                                <li>Personalizzare la tua esperienza con contenuti e annunci pertinenti</li>
                            </ul>

                            <h2>4. Condivisione dei dati</h2>
                            <p>Possiamo condividere i tuoi dati personali con:</p>
                            <ul>
                                <li><strong>Fornitori di servizi:</strong> aziende che ci aiutano a fornire i nostri Servizi</li>
                                <li><strong>Partner commerciali:</strong> per offrirti prodotti o servizi congiunti</li>
                                <li><strong>Autorità legali:</strong> quando richiesto dalla legge o per proteggere i nostri diritti</li>
                            </ul>

                            <h2>5. I tuoi diritti</h2>
                            <p>A seconda della tua giurisdizione, potresti avere i seguenti diritti:</p>
                            <ul>
                                <li>Accedere ai tuoi dati personali</li>
                                <li>Correggere dati inaccurati</li>
                                <li>Cancellare i tuoi dati</li>
                                <li>Opporti al trattamento dei tuoi dati</li>
                                <li>Richiedere la portabilità dei dati</li>
                                <li>Revocare il consenso in qualsiasi momento</li>
                            </ul>

                            <h2>6. Sicurezza dei dati</h2>
                            <p>
                                Adottiamo misure di sicurezza ragionevoli per proteggere i tuoi dati personali da perdita, 
                                uso improprio e accesso non autorizzato. Tuttavia, nessun sistema è completamente sicuro.
                            </p>

                            <h2>7. Conservazione dei dati</h2>
                            <p>
                                Conserviamo i tuoi dati personali solo per il tempo necessario a fornire i Servizi 
                                e per le finalità descritte in questa Informativa sulla Privacy.
                            </p>

                            <h2>8. Modifiche a questa Informativa</h2>
                            <p>
                                Possiamo aggiornare questa Informativa sulla Privacy di tanto in tanto. 
                                Ti informeremo di eventuali modifiche pubblicando la nuova Informativa sulla Privacy su questa pagina.
                            </p>

                            <h2>9. Contattaci</h2>
                            <p>
                                Se hai domande su questa Informativa sulla Privacy, contattaci all'indirizzo: 
                                <a href="mailto:privacy@happyevents.com"> privacy@happyevents.com</a>
                            </p>

                            <p className="mt-5 text-center">
                                Ultima modifica: 12 Luglio 2025
                            </p>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={this.closePrivacy}>
                            {i18n.language === 'en' ? 'Close' : 'Chiudi'}
                        </Button>
                    </Modal.Footer>
                </Modal>
            </>
        );
    }
}

export default RegisterModal;